/*
 * Possible values for orders, mailing, invoice, grn,
 * approval status fields of invoices and orders.
 */

export const _STATUS = {
  error: "error",
  warn: "warn",
  success: "success",
  not_applicable: "not_applicable",
  not_acknowledged: "not_acknowledged",
  red_solid: "red_solid",
  blue_solid: "blue_solid",
  green_solid: "green_solid",
};

export const FINS_ONLY_PO_STATUSES = new Set([
  "pending_acknowledgement",
  "revision_requested",
  "cancellation_requested",
  "vendor_rejected",
]);

export const VENDOR_ACTION_PO_STATUSES = new Set([
  "pending_acknowledgement",
  "revision_requested",
  "cancellation_requested",
]);

export const PO_STATUS_SIDEBAR_ORDER = [
  "all_orders",
  "pending_acknowledgement",
  "confirmed",
  "revision_requested",
  "cancellation_requested",
  "completed",
  "cancelled",
  "vendor_rejected",
];

const MailingStatus = {
  0: {
    label: "Yet to be mailed",
    code: _STATUS.warn,
  },
  1: {
    label: "Mailed",
    code: _STATUS.success,
  },
  2: {
    label: "Failed",
    code: _STATUS.error,
  },
};

const InvoiceStatus = {
  pending: {
    label: "Pending",
    code: _STATUS.warn,
  },
  partial_invoice: {
    label: "Partial Invoice",
    code: _STATUS.warn,
  },
  full_invoice: {
    label: "Full Invoice",
    code: _STATUS.success,
  },
  exception: {
    label: "Exception",
    code: _STATUS.error,
  },
  rejected: {
    label: "Rejected",
    code: _STATUS.error,
  },
  revised: {
    label: "Revised",
    code: _STATUS.warn,
  },
  revision_required: {
    label: "Revision Required",
    code: _STATUS.error,
  },
  submission_requested: {
    label: "Submission Requested",
    code: _STATUS.warn,
  },
  completed: {
    label: "Completed",
    code: _STATUS.success,
  },
  no_invoice: {
    label: "No Invoice Raised",
    code: _STATUS.warn,
  },
};

const GRNStatus = {
  pending: {
    label: "Pending",
    code: _STATUS.warn,
  },
  completed: {
    label: "Completed",
    code: _STATUS.success,
  },
};

const OrderStatus = {
  confirmed: {
    label: "Confirmed",
    code: _STATUS.warn,
  },
  cancelled: {
    label: "Cancelled",
    code: _STATUS.error,
  },
  exception: {
    label: "Exception",
    code: _STATUS.error,
  },
  reconciled: {
    label: "Reconciled",
    code: _STATUS.warn,
  },
  revision_required: {
    label: "Revision Required",
    code: _STATUS.error,
  },
  revised: {
    label: "Revised",
    code: _STATUS.warn,
  },
  completed: {
    label: "Completed",
    code: _STATUS.success,
  },
  completed_with_exception: {
    label: "Completed (Exception)",
    code: _STATUS.success,
  },
  pending: {
    label: "Pending",
    code: _STATUS.warn,
  },
  pending_acknowledgement: {
    label: "NOT ACK",
    code: _STATUS.not_acknowledged,
  },
};

const FinsStatus = {
  created: {
    label: "Acceptance Pending",
    code: _STATUS.not_acknowledged,
  },
  revised: {
    label: "Revised PO – Acknowledgement Pending",
    code: _STATUS.warn,
  },
  cancelled: {
    label: "Cancellation – Acknowledgement Pending",
    code: _STATUS.error,
  },
};

const POStatus = {
  pending_acknowledgement: {
    label: "Pending Ack",
    code: _STATUS.warn,
  },
  confirmed: {
    label: "Confirmed",
    code: _STATUS.green_solid,
  },
  revision_requested: {
    label: "Revision Requested",
    code: _STATUS.blue_solid,
  },
  cancellation_requested: {
    label: "Cancellation Requested",
    code: _STATUS.red_solid,
  },
  cancelled: {
    label: "Cancelled",
    code: _STATUS.error,
  },
  completed: {
    label: "Completed",
    code: _STATUS.success,
  },
  vendor_rejected: {
    label: "Vendor Rejected",
    code: _STATUS.error,
  },
};

const ApprovalStatus = {
  approved: {
    label: "Approved",
    code: _STATUS.success,
  },
  pending: {
    label: "Pending",
    code: _STATUS.warn,
  },
  rejected: {
    label: "Rejected",
    code: _STATUS.error,
  },
  not_required: {
    label: "Not Required",
    code: _STATUS.not_applicable,
  },
};

export {
  ApprovalStatus,
  GRNStatus,
  InvoiceStatus,
  MailingStatus,
  OrderStatus,
  FinsStatus,
  POStatus,
};
